import { DELETE_REQUEST_DELEGATION } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const deleteRequestDelegationAction = (pid) => {
    return {
        type: DELETE_REQUEST_DELEGATION,
        payload: pid,
    };
};
